"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CibliError = void 0;
class CibliError extends Error {
    constructor(message, code) {
        super(message);
        this.name = 'CibliError';
        this.response = {
            data: {
                message,
                code,
            },
        };
    }
}
exports.CibliError = CibliError;
